import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-minnesota-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./minnesota-state-form.component.html",
  styleUrl: "./minnesota-state-form.component.scss",
})
export class MinnesotaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
